// extracted by mini-css-extract-plugin
export const root = "Lead-module--root--jpJSp";
export const not_contained = "Lead-module--not_contained--3b4BF";
export const chart_container = "Lead-module--chart_container--Z_jvw";
export const container = "Lead-module--container--3tsL2";
export const contained = "Lead-module--contained--3M0bz";
export const right_image = "Lead-module--right_image--1Ujfy";
export const title = "Lead-module--title--3tXuj";
export const subtitle = "Lead-module--subtitle--3X96L";
export const button_container = "Lead-module--button_container--11gp2";